var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause10 = function SvgIconPause10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 69"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M63.969 13.666 35.5 0 7.031 13.666 0 44.374 19.701 69h31.598L71 44.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M37.205 41.999H41V31h-3.795v10.999zM30 42h3.795V31.001H30V42z"
  }))));
};
export default SvgIconPause10;